import { CartesianGrid, CartesianGridProps, XAxis, XAxisProps, YAxis, YAxisProps } from 'recharts';

import {
  Brand60,
  Channel1,
  Channel2,
  Channel4,
  Channel5,
  Channel6,
  Neutral300,
  Neutral500,
  Neutral900
} from '../../utils/colors';

// Shared chart style values. Charts and pages take axes, grid, margins and palettes from here
// instead of hand-writing recharts props.
const CHART_MARGIN = { top: 8, right: 12, bottom: 8, left: 8 };

export const CHART_PRESET = {
  margin: CHART_MARGIN,
  // A numeric bottom axis (horizontal bars, scatter) ends on a tick label centred on the plot's right
  // edge ("$6.0M"); the wider right margin keeps that label from being clipped.
  numericXMargin: { ...CHART_MARGIN, right: 24 },
  gridStroke: Neutral300,
  gridStrokeWidth: 1,
  // The one allowed chart font size; recharts tick props need a number.
  axisTickFontSize: 12,
  axisTickColor: Neutral500,
  lineStrokeWidth: 2,
  // Default series palette, used when an encoding channel doesn't pin its own `color`. Brand first
  // so single-series charts read as on-brand; the rest are the categorical Channel palette spread
  // for contrast (skipping the Channel hues closest to brand purple).
  seriesPalette: [Brand60, Channel4, Channel2, Channel6, Channel5, Channel1],
  // Default colors for a combo's overlay lines drawn over a color split. Neutrals, so a line never
  // shares a hue with one of the split's categorical series.
  overlayPalette: [Neutral900, Neutral500],
  // Widest a bar may draw, in px. Without a cap a short date range stretches each bar to fill its band.
  barMaxWidth: 48
} as const;

export const CHART_TICK_STYLE = {
  fontSize: CHART_PRESET.axisTickFontSize,
  fill: CHART_PRESET.axisTickColor
};

export const ChartXAxis = (props: XAxisProps) => (
  <XAxis
    tick={CHART_TICK_STYLE}
    tickLine={false}
    axisLine={{ stroke: CHART_PRESET.gridStroke }}
    {...props}
  />
);

export const ChartYAxis = (props: YAxisProps) => (
  <YAxis tick={CHART_TICK_STYLE} tickLine={false} axisLine={false} {...props} />
);

export const ChartGrid = (props: CartesianGridProps) => (
  <CartesianGrid
    stroke={CHART_PRESET.gridStroke}
    strokeWidth={CHART_PRESET.gridStrokeWidth}
    {...props}
  />
);
